import { ref } from 'vue'

const eventBus = ref({
  events: new Map(),
  on(eventName, callback) {
    if (!this.events.has(eventName)) {
      this.events.set(eventName, [])
    }
    this.events.get(eventName)?.push(callback)
  },
  emit(eventName, ...args) {
    const callbacks = this.events.get(eventName)
    if (callbacks) {
      callbacks.forEach((callback) => {
        callback(...args)
      })
    }
  }
})

export default eventBus.value
